<template>
    <control-panel
        :breadcrumbs="breadcrumbsItems"
        :title="$t('reports.reports')"
    >

        <template #right>
            <report-filters>
                <template #append>
                    <v-btn
                        v-if="checkPermission('REPORTS_ADD')"
                        class="v-btn--primary"
                        @click="onNewReportButtonClick"
                        link
                    >
                        {{ $t('reports.new') }}
                    </v-btn>
                </template>
            </report-filters>
        </template>

    </control-panel>

</template>

<script>
import ControlPanel from "@/Shared/ControlPanel";
import ReportFilters from "./ReportFilters";
import {i18n} from "@/i18n";
import _ from "lodash";
import {mapState} from "pinia/dist/pinia";
import {PermissionsStore} from "@/Store/PermissionsStore";
import {mapActions} from "pinia";

export default {
    name: "ReportHeader",

    components: {ReportFilters, ControlPanel},

    props: {
        type: {
            type: Object,
        },
    },

    data() {
        return {

        }
    },

    methods: {
        onNewReportButtonClick() {

            this.$inertia.get(route('reports.generate', {'type': this.reportTypeRouteParameter}));
        },

        ...mapActions(PermissionsStore, ['checkPermission']),
    },

    computed: {
        /**
         *
         * @returns {[{disabled: boolean, text: *},{disabled: boolean, text: *, href: *}]}
         */
        breadcrumbsItems() {
            return [
                {
                    text: i18n.t(`reports.types.${this.reportTypeRouteParameter}`),
                    disabled: true,
                },
                {
                    text: i18n.t('reports.list'),
                    disabled: false,
                    href: route('reports.index', {'type': this.reportTypeRouteParameter}),
                },
            ];
        },

        /**
         *
         * @returns {*}
         */
        reportTypeRouteParameter() {
            return _.get(this.type, 'route_type_parameter');
        },
    }

}
</script>

<style scoped>

</style>
